export const citationStyles = [
  {
    id: 1,
    customerName: "MLA",
  },
  {
    id: 2,
    customerName: "APA",
  },
  {
    id: 3,
    customerName: "Chicago",
  },
  {
    id: 4,
    customerName: "Turabian",
  },
  {
    id: 5,
    customerName: "AMA",
  },
  {
    id: 6,
    customerName: "IEEE",
  },
  {
    id: 7,
    customerName: "ASA",
  },
  {
    id: 8,
    customerName: "Harvard",
  },
  {
    id: 9,
    customerName: "APSA",
  },
  {
    id: 10,
    customerName: "CSE",
  },
];
